import React from "react";
import {Colors, Container, Text} from "@bounce/shared/ui";
import {InputAdornment, TextField, Typography} from "@mui/material";
import {divide, formatCurrency, multiply} from "@bounce/shared/helpers";
import {getAmountValidationHelperText} from "../utils";
import {minPartialPaymentInCents} from "constants/defaultValues";

interface ICustomPaymentBox {
  isValid: boolean;
  amount: number | undefined;
  totalBalance: number;
  setAmount: (amount: number) => void;
  title?: string;
}

const CustomPaymentBox = ({isValid, totalBalance, amount, setAmount, title}: ICustomPaymentBox) => {
  return (
    <Container fullWidth>
      {title && (
        <Text fontWeight={"medium"} sx={{alignItems: "start", width: "100%"}}>
          {title}
        </Text>
      )}
      <TextField
        type={"number"}
        fullWidth
        onChange={(event) => setAmount(multiply(Number(event.target.value), 100))}
        error={!isValid}
        helperText={getAmountValidationHelperText({isValid, amount, totalBalance})}
        InputProps={{
          style: {borderRadius: "8px"},
          slotProps: {
            input: {
              style: {fontWeight: 500},
              min: totalBalance < minPartialPaymentInCents ? 0.01 : divide(minPartialPaymentInCents, 100),
              max: divide(totalBalance, 100),
            },
          },
          startAdornment: (
            <InputAdornment position="start">
              <Typography sx={{color: "text.primary", fontWeight: 500}}>{"$"}</Typography>
            </InputAdornment>
          ),
        }}
        sx={{backgroundColor: Colors.bw.white}}
      />
      <Text size={14} sx={{color: Colors.grey._700}}>
        (Maximal amount {formatCurrency(totalBalance)})
      </Text>
    </Container>
  );
};

export default CustomPaymentBox;
